/* free-ccw-offer.js — IL (Hebrew / RTL / ₪)
 * Ported from the ROW-US pilot (B2C-ROW-US-agilitegear) on 2026-06-23.
 * "Free gift with purchase" storefront UI (free Hook-Backed CCW Strap /
 * רצועת CCW with the Emergence Fanny Pack / פאוץ'). UI ONLY — the actual ₪0 is a
 * Shopify automatic "Buy X Get Y" discount (Buy trigger -> Get gift free), which
 * also reverts the gift to full price if the trigger is removed, on both PDPs +
 * checkout. THE DISCOUNT MUST BE CREATED IN THE IL ADMIN — without it the strap
 * stays full price. The countdown is URGENCY UI only; align OFFER_ENDS_AT with
 * the IL discount's end date.
 *
 * IL port changes vs ROW: product/variant ids (IL store), Hebrew copy, ₪ money,
 * RTL-safe alignment (text-align:start). Logic is identical to ROW. Verify on
 * PREVIEW (RTL layout + Prestige selectors).
 */
(function () {
  'use strict';

  // Diagnostic log (intentionally on LIVE too) so it's easy to see in F12 why the
  // CCW⇄fanny card does or doesn't render on each store. Prefixed for filtering.
  function fcclog() { try { console.log.apply(console, ['%c[free-ccw]', 'color:#dc2626;font-weight:700'].concat([].slice.call(arguments))); } catch (e) {} }

  // *** Offer end — Saturday 27/06/2026, end of day (UTC). Match this to the IL
  //     Buy-X-Get-Y discount's end date. For exact local end-of-Saturday in
  //     Israel, use '2026-06-27T23:59:59+03:00'. ***
  var OFFER_ENDS_AT = '2026-06-27T18:00:00+03:00';  // Saturday 27/06/2026, 18:00 Jerusalem (IDT=UTC+3 → 15:00 UTC). Pinned for every shopper. Match the Buy-X-Get-Y discount end to this.

  // === Offers: trigger product -> free gift. IL store ids. ===================
  var OFFERS = [
    {
      triggerHandle:    'emergence-fanny-pack',
      triggerProductId: 10084018454813,
      giftHandle:       'hook-backed-ccw-strap',
      giftVariantId:    51916747473181,   // single-variant gift (IL)
      giftProductId:    10242004713757,
      giftName:         'רצועת CCW',
      triggerName:      "פאוץ' Emergence",
      label:            'קבלו רצועת CCW חינם!'
    }
  ];

  var path = location.pathname || '';
  function offerFor(role) {
    for (var i = 0; i < OFFERS.length; i++) {
      if (path.indexOf('/products/' + OFFERS[i][role]) !== -1) return OFFERS[i];
    }
    return null;
  }
  var triggerOffer = offerFor('triggerHandle');
  var giftOffer    = offerFor('giftHandle');
  if (!triggerOffer && !giftOffer) {
    if (path.indexOf('/products/') !== -1) fcclog('no CCW offer matches this product page —', path);
    return;
  }

  function offerEndMs(offer) { return Date.parse(offer.endsAt || OFFER_ENDS_AT); }
  function offerExpired(offer) { var e = offerEndMs(offer); return !isNaN(e) && Date.now() >= e; }
  function fmtRemaining(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;
    return d + 'd ' + h + 'h ' + m + 'm ' + s + 's';
  }

  // ---- shared cart helpers (mirror easy-suggestion-system.js) ----
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }
  function cartSectionKeys() {
    var keys = [];
    var drawer = document.querySelector('[id^="shopify-section-"][id$="__cart-drawer"]')
              || document.querySelector('[id^="shopify-section-"][id*="cart-drawer"]')
              || document.querySelector('[id^="shopify-section-"][id*="cart"]');
    if (drawer) keys.push(drawer.id.replace('shopify-section-', ''));
    var bubble = document.querySelector('[id^="shopify-section-"][id$="__cart-icon-bubble"]');
    if (bubble) keys.push(bubble.id.replace('shopify-section-', ''));
    var uniq = [];
    keys.forEach(function (k) { if (uniq.indexOf(k) === -1) uniq.push(k); });
    return uniq;
  }
  function refreshCartSections() {
    var keys = cartSectionKeys();
    if (!keys.length) return Promise.resolve();
    return fetch('/?sections=' + keys.map(encodeURIComponent).join(','), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections) return;
        Object.keys(sections).forEach(function (key) {
          var el = document.getElementById('shopify-section-' + key);
          if (el && typeof sections[key] === 'string') el.innerHTML = sections[key];
        });
      }).catch(function () {});
  }
  function openCartDrawer() {
    var d = document.querySelector('cart-drawer') || document.querySelector('[id*="cart-drawer"]');
    if (d && typeof d.open === 'function') { try { d.open(); return; } catch (e) {} }
    var toggle = document.querySelector('#cart-icon-bubble, a[href$="/cart"], [aria-controls*="cart"], [aria-controls*="Cart"]');
    if (toggle) { try { toggle.click(); } catch (e) {} }
  }
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function cartHasProduct(cart, productId) {
    return !!(cart && cart.items && cart.items.some(function (it) { return it && it.product_id === productId; }));
  }
  function firstVariantId(handle, cb) {
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) { cb(null); return; }
        var v = null;
        for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
        cb((v || p.variants[0]).id);
      }).catch(function () { cb(null); });
  }
  function fetchProductJson(handle) {
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  // True only if the product has at least one purchasable (available) variant.
  function productInStock(p) {
    return !!(p && p.variants && p.variants.some(function (v) { return v && v.available; }));
  }

  // ============= countdown-framed "free gift" card (trigger OR gift page) ======
  // `companionProd` is the already-fetched companion product (passed from boot,
  // where both products' stock was verified) — so no second fetch here.
  function initOfferButton(offer, role, companionProd) {
    if (offerExpired(offer)) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    // The gift may be out of stock — still show the Free-gift card + timer as a
    // teaser (non-selectable, with a "sold out" badge) so the urgency continues.
    var compInStock = productInStock(companionProd);
    var selected = false;
    var companionHandle  = (role === 'trigger') ? offer.giftHandle    : offer.triggerHandle;
    var companionVariant = (role === 'trigger') ? offer.giftVariantId : null;
    var eyebrowText = (role === 'trigger') ? 'הוסיפו בחינם להזמנה שלכם'
                                           : ('הוסיפו ' + offer.triggerName + ' וקבלו ' + offer.giftName + ' חינם');
    var nameText = (role === 'trigger') ? offer.giftName : offer.triggerName;

    var wrap = document.createElement('div');
    wrap.className = 'free-ccw-offer';
    wrap.innerHTML =
      '<div class="free-ccw-offer__timer" hidden>' +
        '<span class="free-ccw-offer__timer-label">המבצע מסתיים בעוד</span> ' +
        '<span class="free-ccw-offer__countdown"></span>' +
      '</div>' +
      '<div class="free-ccw-offer__body">' +
        '<p class="free-ccw-offer__eyebrow">' +
          '<span class="free-ccw-offer__eyebrow-txt"></span></p>' +
        '<div class="free-ccw-offer__btn" role="button" tabindex="0" aria-pressed="false">' +
          '<a class="free-ccw-offer__thumb-link" tabindex="-1" aria-hidden="true">' +
            '<img class="free-ccw-offer__thumb" alt="" hidden>' +
          '</a>' +
          '<span class="free-ccw-offer__info">' +
            '<a class="free-ccw-offer__name"></a>' +
            '<span class="free-ccw-offer__price"></span>' +
          '</span>' +
          '<span class="free-ccw-offer__check" aria-hidden="true"></span>' +
        '</div>' +
      '</div>';
    wrap.querySelector('.free-ccw-offer__eyebrow-txt').textContent = eyebrowText;
    wrap.querySelector('.free-ccw-offer__name').textContent = nameText;
    var btn     = wrap.querySelector('.free-ccw-offer__btn');
    var thumb   = wrap.querySelector('.free-ccw-offer__thumb');
    var priceEl = wrap.querySelector('.free-ccw-offer__price');
    if (role === 'gift') priceEl.textContent = 'הוסיפו להזמנה';
    else priceEl.innerHTML = '<b class="free-ccw-offer__freeword">חינם</b>';

    // Thumbnail + name link to the companion product's PDP. Clicking them
    // navigates; clicking anywhere else on the card toggles selection.
    var pdpUrl    = '/products/' + companionHandle;
    var thumbLink = wrap.querySelector('.free-ccw-offer__thumb-link');
    var nameLink  = wrap.querySelector('.free-ccw-offer__name');
    thumbLink.href = pdpUrl;
    nameLink.href  = pdpUrl;
    nameLink.setAttribute('aria-label', 'צפייה ב' + nameText);
    [thumbLink, nameLink].forEach(function (lnk) {
      lnk.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    if (compInStock) {
      var toggle = function () {
        selected = !selected;
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      };
      btn.addEventListener('click', toggle);
      btn.addEventListener('keydown', function (e) {
        if (e.target !== btn) return;                 // let the inner links handle their own keys
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggle(); }
      });
    } else {
      // Out of stock: keep the Free-gift card + timer as a teaser; make it
      // non-selectable and badge the gift "sold out".
      wrap.classList.add('free-ccw-offer--soldout');
      btn.removeAttribute('role');
      btn.removeAttribute('tabindex');
      btn.setAttribute('aria-disabled', 'true');
      var soldEl = wrap.querySelector('.free-ccw-offer__check');
      if (soldEl) { soldEl.className = 'free-ccw-offer__soldout'; soldEl.removeAttribute('aria-hidden'); soldEl.textContent = 'אזל מהמלאי'; }
    }

    // Countdown timer (urgency only). Removes the whole card when it hits zero.
    var endMs = offerEndMs(offer);
    if (!isNaN(endMs)) {
      var timerEl = wrap.querySelector('.free-ccw-offer__timer');
      var cd = wrap.querySelector('.free-ccw-offer__countdown');
      timerEl.hidden = false;
      var iv;
      var tick = function () {
        var rem = endMs - Date.now();
        if (rem <= 0) {
          clearInterval(iv);
          if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
          return;
        }
        cd.textContent = fmtRemaining(rem);
      };
      tick();
      iv = setInterval(tick, 1000);
    }

    // Companion product (already fetched + verified in stock in boot): thumbnail,
    // struck price (trigger page), variant to add. No second fetch.
    (function (p) {
      if (!p) return;
      var img = p.featured_image || (p.images && p.images[0]) || null;
      var url = (typeof img === 'string') ? img : (img && img.src) || '';
      if (url) {
        thumb.src = url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
        thumb.alt = p.title || nameText;
        thumb.hidden = false;
      }
      if (typeof p.price === 'number') {
        if (role === 'trigger') {
          // The freebie: strike its price -> FREE.
          priceEl.innerHTML = '<s class="free-ccw-offer__was"></s> <b class="free-ccw-offer__freeword">חינם</b>';
          priceEl.querySelector('.free-ccw-offer__was').textContent = '₪' + (p.price / 100).toFixed(2);
        } else {
          // Gift page: the trigger isn't free -> show its real price.
          priceEl.textContent = '₪' + (p.price / 100).toFixed(2);
        }
      }
      if (companionVariant == null && p.variants && p.variants.length) {
        var v = null;
        for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
        companionVariant = (v || p.variants[0]).id;
      }
    })(companionProd);

    var picker = document.querySelector('variant-picker, variant-radios, variant-selects, .variant-picker, [id^="variant-radios"]');
    if (picker && picker.parentNode) {
      picker.parentNode.insertBefore(wrap, picker.nextSibling);
    } else {
      var atc0 = form.querySelector('[name="add"]');
      (atc0 && atc0.parentNode ? atc0.parentNode : form).insertBefore(wrap, atc0 || form.firstChild);
    }

    form.addEventListener('submit', function (e) {
      if (!selected) return;
      var idInput = form.querySelector('[name="id"]');
      var pageVariant = idInput && parseInt(idInput.value, 10);
      if (!pageVariant) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var atcEl = form.querySelector('[name="add"]');
      if (atcEl) atcEl.setAttribute('aria-busy', 'true');
      var go = function (companion) {
        var items = companion
          ? [{ id: pageVariant, quantity: 1 }, { id: companion, quantity: 1 }]
          : [{ id: pageVariant, quantity: 1 }];
        addItems(items).then(refreshCartSections).then(openCartDrawer)
          .catch(function () { return addItems([{ id: pageVariant, quantity: 1 }]).then(refreshCartSections).then(openCartDrawer); })
          .catch(function () {})
          .then(function () { if (atcEl) atcEl.removeAttribute('aria-busy'); });
      };
      if (companionVariant != null) go(companionVariant);
      else firstVariantId(companionHandle, go);
    }, true);
  }

  // ====================== gift-page status note ======================
  function initGiftNote(offer) {
    if (offerExpired(offer)) return;
    function paint(cart) {
      var free = cartHasProduct(cart, offer.triggerProductId);
      var note = document.getElementById('free-ccw-note');
      if (!note) {
        note = document.createElement('p');
        note.id = 'free-ccw-note';
        note.className = 'free-ccw-note';
        var price = document.querySelector('.price, .product__price, [class*="price"]');
        if (price && price.parentNode) price.parentNode.insertBefore(note, price.nextSibling);
        else (document.querySelector('.product-info, .product, main') || document.body).appendChild(note);
      }
      note.classList.toggle('is-free', free);
      note.textContent = free
        ? '✓ חינם — עלינו, יחד עם ' + offer.triggerName + ' (כבר בעגלה שלך)'
        : 'חינם בהוספה יחד עם ' + offer.triggerName;
    }
    getCart().then(paint);
    document.addEventListener('cart:change', function () { getCart().then(paint); });
    window.addEventListener('pageshow', function () { getCart().then(paint); });
  }

  // =============== easy suggestion (fanny-pack page, NO promo) ================
  // Shown instead of the free-gift promo when the promo isn't active (timer out
  // OR out of stock) — a plain CCW cross-sell at its real price, with its own Add
  // button. Only rendered when the CCW itself is in stock (caller's job).
  function initEasySuggestion(offer, giftProd) {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || !giftProd) { fcclog('easy-suggestion NOT rendered — add-to-cart form found:', !!form, '· gift product found:', !!giftProd); return; }
    var inStock = productInStock(giftProd);
    var variantId = offer.giftVariantId;
    if (variantId == null && giftProd.variants) {
      for (var i = 0; i < giftProd.variants.length; i++) { if (giftProd.variants[i].available) { variantId = giftProd.variants[i].id; break; } }
    }
    // No bail when out of stock: keep the cross-sell card visible (it still links to
    // the PDP); the Add button below becomes a disabled "Sold out" instead.
    var pdpUrl = '/products/' + offer.giftHandle;
    // Show the countdown even when out of stock — only hide it once the offer
    // window itself has ended (urgency UI only; doesn't control the discount).
    var showTimer = !offerExpired(offer);

    var selected = false;
    var wrap = document.createElement('div');
    wrap.className = 'free-ccw-suggest';
    wrap.innerHTML =
      (showTimer ? '<div class="free-ccw-suggest__timer"><span class="free-ccw-suggest__timer-ic">⏳</span> <span class="free-ccw-suggest__countdown"></span></div>' : '') +
      '<p class="free-ccw-suggest__eyebrow">השלימו את הסט</p>' +
      '<div class="free-ccw-suggest__row' + (inStock ? ' free-ccw-suggest__row--select' : '') + '"' +
        (inStock ? ' role="button" tabindex="0" aria-pressed="false"' : '') + '>' +
        '<a class="free-ccw-suggest__thumb-link"><img class="free-ccw-suggest__thumb" alt="" hidden></a>' +
        '<span class="free-ccw-suggest__info">' +
          '<a class="free-ccw-suggest__name"></a>' +
          '<span class="free-ccw-suggest__price"></span>' +
        '</span>' +
        (inStock
          ? '<span class="free-ccw-suggest__check" aria-hidden="true"></span>'
          : '<span class="free-ccw-suggest__soldout">אזל מהמלאי</span>') +
      '</div>';
    var nameEl  = wrap.querySelector('.free-ccw-suggest__name');
    var priceEl = wrap.querySelector('.free-ccw-suggest__price');
    var thumb   = wrap.querySelector('.free-ccw-suggest__thumb');
    var rowEl   = wrap.querySelector('.free-ccw-suggest__row');
    nameEl.textContent = offer.giftName;
    nameEl.href = pdpUrl;
    nameEl.setAttribute('aria-label', 'צפייה ב' + offer.giftName);
    wrap.querySelector('.free-ccw-suggest__thumb-link').href = pdpUrl;
    [wrap.querySelector('.free-ccw-suggest__thumb-link'), nameEl].forEach(function (lnk) {
      lnk.addEventListener('click', function (e) { e.stopPropagation(); });
    });

    var img = giftProd.featured_image || (giftProd.images && giftProd.images[0]) || null;
    var url = (typeof img === 'string') ? img : (img && img.src) || '';
    if (url) { thumb.src = url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160'; thumb.alt = giftProd.title || offer.giftName; thumb.hidden = false; }
    if (typeof giftProd.price === 'number') priceEl.textContent = '₪' + (giftProd.price / 100).toFixed(2);

    if (inStock && variantId != null) {
      // Checkbox-style select (NO separate Add button): tick the row, then the
      // shopper's normal Add-to-Cart adds BOTH this product + the CCW.
      var toggle = function () {
        selected = !selected;
        rowEl.classList.toggle('is-selected', selected);
        rowEl.setAttribute('aria-pressed', selected ? 'true' : 'false');
      };
      rowEl.addEventListener('click', toggle);
      rowEl.addEventListener('keydown', function (e) {
        if (e.target !== rowEl) return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggle(); }
      });
      form.addEventListener('submit', function (e) {
        if (!selected) return;
        var idInput = form.querySelector('[name="id"]');
        var pageVariant = idInput && parseInt(idInput.value, 10);
        if (!pageVariant) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var atcEl = form.querySelector('[name="add"]');
        if (atcEl) atcEl.setAttribute('aria-busy', 'true');
        addItems([{ id: pageVariant, quantity: 1 }, { id: variantId, quantity: 1 }])
          .then(refreshCartSections).then(openCartDrawer)
          .catch(function () { return addItems([{ id: pageVariant, quantity: 1 }]).then(refreshCartSections).then(openCartDrawer); })
          .catch(function () {})
          .then(function () { if (atcEl) atcEl.removeAttribute('aria-busy'); });
      }, true);
    }

    // Countdown on the cross-sell card — runs even out of stock; hides itself when
    // the offer window ends. Reuses the same end time + formatter as the promo card.
    if (showTimer) {
      var _endMs = offerEndMs(offer);
      var _cd = wrap.querySelector('.free-ccw-suggest__countdown');
      var _tw = wrap.querySelector('.free-ccw-suggest__timer');
      if (!isNaN(_endMs) && _cd) {
        var _iv;
        var _tick = function () {
          var rem = _endMs - Date.now();
          if (rem <= 0) { clearInterval(_iv); if (_tw) _tw.hidden = true; return; }
          _cd.textContent = fmtRemaining(rem);
        };
        _tick();
        _iv = setInterval(_tick, 1000);
      }
    }

    var picker = document.querySelector('variant-picker, variant-radios, variant-selects, .variant-picker, [id^="variant-radios"]');
    if (picker && picker.parentNode) picker.parentNode.insertBefore(wrap, picker.nextSibling);
    else { var atc0 = form.querySelector('[name="add"]'); (atc0 && atc0.parentNode ? atc0.parentNode : form).insertBefore(wrap, atc0 || form.firstChild); }
  }

  // -------------------------------- styles ----------------------------------
  var css = document.createElement('style');
  css.textContent =
    '.free-ccw-offer{margin:18px 0;border:1px solid #e4e4e7;border-radius:14px;background:#fafafa;overflow:hidden}' +
    '.free-ccw-offer__timer{display:flex;align-items:baseline;gap:6px;flex-wrap:wrap;' +
      'padding:13px 14px 0;font-size:.92rem;font-weight:700;color:#111}' +
    '.free-ccw-offer__timer-label{color:#111;font-weight:700}' +
    '.free-ccw-offer__countdown{font-variant-numeric:tabular-nums;font-size:1.08rem;font-weight:900;letter-spacing:.03em;color:#dc2626}' +
    '.free-ccw-offer__body{padding:14px}' +
    '.free-ccw-offer__eyebrow{display:flex;align-items:center;gap:6px;margin:0 0 8px;' +
      'font-size:.78rem;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#dc2626}' +
    '.free-ccw-offer__gift{font-size:1rem;line-height:1}' +
    '.free-ccw-offer__btn{display:flex;align-items:center;gap:12px;width:100%;text-align:start;' +
      'padding:12px 14px;border:2px solid #e4e4e7;border-radius:12px;background:#fff;cursor:pointer;' +
      'transition:border-color .15s ease,background .15s ease,box-shadow .15s ease}' +
    '.free-ccw-offer__btn:hover{border-color:#dc2626;box-shadow:0 2px 12px rgba(220,38,38,.13)}' +
    '.free-ccw-offer__btn.is-selected{border-color:#dc2626;background:#fef2f2}' +
    '.free-ccw-offer__thumb-link{display:block;flex:0 0 auto;line-height:0;border-radius:9px;overflow:hidden}' +
    '.free-ccw-offer__thumb{width:52px;height:52px;flex:0 0 auto;object-fit:cover;border-radius:9px;background:#f3f4f6}' +
    '.free-ccw-offer__info{display:flex;flex-direction:column;gap:2px;min-width:0;flex:1 1 auto}' +
    '.free-ccw-offer__name{font-weight:700;font-size:.98rem;color:#111;text-decoration:none;display:inline-block;align-self:flex-start;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.free-ccw-offer__name:hover{text-decoration:underline}' +
    '.free-ccw-offer__price{font-size:.9rem;color:#6b7280}' +
    '.free-ccw-offer__was{color:#9ca3af}' +
    '.free-ccw-offer__freeword{color:#dc2626;font-weight:800;letter-spacing:.03em}' +
    '.free-ccw-offer__check{flex:0 0 auto;width:26px;height:26px;border-radius:50%;border:2px solid #cfcfcf;' +
      'position:relative;transition:background .15s ease,border-color .15s ease}' +
    '.free-ccw-offer__btn:hover .free-ccw-offer__check{border-color:#dc2626}' +
    '.free-ccw-offer__btn.is-selected .free-ccw-offer__check{background:#dc2626;border-color:#dc2626}' +
    '.free-ccw-offer__btn.is-selected .free-ccw-offer__check::after{content:"";position:absolute;left:8px;top:4px;' +
      'width:5px;height:10px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}' +
    '.free-ccw-offer--soldout .free-ccw-offer__btn{cursor:default}' +
    '.free-ccw-offer--soldout .free-ccw-offer__btn:hover{border-color:#e4e4e7;box-shadow:none}' +
    '.free-ccw-offer__soldout{flex:0 0 auto;font-size:.72rem;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#b91c1c;background:#fee2e2;border-radius:999px;padding:4px 10px;white-space:nowrap}' +
    '.free-ccw-suggest{margin:18px 0;border:1px solid #e4e4e7;border-radius:14px;padding:14px;background:#fafafa}' +
    '.free-ccw-suggest__timer{display:flex;align-items:center;justify-content:center;gap:8px;flex-wrap:wrap;' +
      'background:#dc2626;color:#fff;margin:-14px -14px 12px;padding:10px 12px;border-radius:13px 13px 0 0;' +
      'font-size:.85rem;font-weight:800;letter-spacing:.04em;text-transform:uppercase}' +
    '.free-ccw-suggest__timer-ic{line-height:1;font-size:1.05rem}' +
    '.free-ccw-suggest__countdown{font-variant-numeric:tabular-nums;font-size:1.08rem;font-weight:900;letter-spacing:.05em}' +
    '.free-ccw-suggest__eyebrow{margin:0 0 10px;font-size:.78rem;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#6b7280}' +
    '.free-ccw-suggest__row{display:flex;align-items:center;gap:12px}' +
    '.free-ccw-suggest__thumb-link{display:block;flex:0 0 auto;line-height:0;border-radius:9px;overflow:hidden}' +
    '.free-ccw-suggest__thumb{width:52px;height:52px;flex:0 0 auto;object-fit:cover;border-radius:9px;background:#f3f4f6}' +
    '.free-ccw-suggest__info{display:flex;flex-direction:column;gap:2px;min-width:0;flex:1 1 auto}' +
    '.free-ccw-suggest__name{align-self:flex-start;font-weight:700;font-size:.98rem;color:#111;text-decoration:none;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.free-ccw-suggest__name:hover{text-decoration:underline}' +
    '.free-ccw-suggest__price{font-size:.9rem;color:#6b7280}' +
    '.free-ccw-suggest__row--select{cursor:pointer;border:2px solid #e4e4e7;border-radius:12px;padding:10px 12px;background:#fff;transition:border-color .15s ease,background .15s ease,box-shadow .15s ease}' +
    '.free-ccw-suggest__row--select:hover{border-color:#111;box-shadow:0 2px 12px rgba(0,0,0,.08)}' +
    '.free-ccw-suggest__row--select.is-selected{border-color:#111;background:#f3f4f6}' +
    '.free-ccw-suggest__check{flex:0 0 auto;width:24px;height:24px;border-radius:6px;border:2px solid #cfcfcf;position:relative;transition:background .15s ease,border-color .15s ease}' +
    '.free-ccw-suggest__row--select:hover .free-ccw-suggest__check{border-color:#111}' +
    '.free-ccw-suggest__row--select.is-selected .free-ccw-suggest__check{background:#111;border-color:#111}' +
    '.free-ccw-suggest__row--select.is-selected .free-ccw-suggest__check::after{content:"";position:absolute;left:7px;top:3px;width:5px;height:10px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}' +
    '.free-ccw-suggest__soldout{flex:0 0 auto;font-size:.72rem;font-weight:800;letter-spacing:.04em;text-transform:uppercase;color:#b91c1c;background:#fee2e2;border-radius:999px;padding:4px 10px;white-space:nowrap}' +
    '.free-ccw-note{margin:10px 0;font-weight:700;color:#111}' +
    '.free-ccw-note.is-free{color:#dc2626}';
  document.head.appendChild(css);

  function boot() {
    var offer = triggerOffer || giftOffer;
    if (!offer) return;
    // Decide promo vs. fallback from LIVE stock + the timer. The free-gift promo
    // shows only if the timer is still running AND both products are in stock.
    // Otherwise, on the fanny-pack page only, fall back to a plain CCW cross-sell
    // ("easy suggestion") — but only when the CCW itself is buyable. The CCW page
    // shows the promo or nothing.
    Promise.all([fetchProductJson(offer.triggerHandle), fetchProductJson(offer.giftHandle)])
      .then(function (prods) {
        var trigIn = productInStock(prods[0]);
        var giftIn = productInStock(prods[1]);
        var promoActive = !offerExpired(offer) && trigIn && giftIn;
        fcclog('page', path);
        fcclog('trigger', offer.triggerHandle, '— found:', !!prods[0], '· inStock:', trigIn);
        fcclog('gift', offer.giftHandle, '— found:', !!prods[1], '· inStock:', giftIn);
        fcclog('offerExpired:', offerExpired(offer), '· promoActive:', promoActive);
        if (triggerOffer) {                       // on the fanny-pack page
          // Show the FREE-GIFT card while the offer window is open — even out of
          // stock (renders a non-selectable "sold out" teaser that keeps the timer).
          if (!offerExpired(offer)) { fcclog('→ FREE-GIFT card (gift inStock=' + giftIn + ')'); initOfferButton(triggerOffer, 'trigger', prods[1]); }
          else { fcclog('→ easy-suggestion card (offer expired)'); initEasySuggestion(triggerOffer, prods[1]); }
        } else if (giftOffer) {                   // on the CCW page (promo only)
          if (promoActive) { fcclog('→ PROMO on gift page'); initOfferButton(giftOffer, 'gift', prods[0]); initGiftNote(giftOffer); }
          else fcclog('→ gift page, promo off — nothing shown');
        }
      });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
